import { festivalApi } from '../../api/festivals';
import { createContentSlice } from './contentSlice';

const { slice, actions } = createContentSlice({
  name: 'festivals',
  api: festivalApi,
  hasPublish: false,
  keyField: 'id',
});

export const festivalReducer = slice.reducer;
export const festivalActions = actions;

export const selectFestivals = (state) => state.festivals.items;
export const selectFestivalsStatus = (state) => state.festivals.status;